




























































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { DateTime } from 'luxon';
import { defaultTimezone } from '@/services/config';
import { FormTargetingVO, TFormSaveDetailRequest } from '@/model/FormWheel';
import { getQueryVariable } from '@/services/api';

@Component({})
class PopSetting extends Vue {
  @Prop(Object)
  formData!: TFormSaveDetailRequest;

  @Prop(Object)
  targetingData!: FormTargetingVO;

  @Prop(Object)
  rulesData!: any;

  @Prop(String)
  activeTag?: string;

  @Prop({ type: Boolean, default: false })
  publishLoading!: boolean;

  targeting = this.targetingData;

  effectiveType = 'always'; // always/custom

  effectiveStartDate: string = '';
  effectiveStartTime: string = '';
  effectiveEndDate: string = '';
  effectiveEndTime: string = '';

  validation = {
    startDateError: false,
    startTimeError: false,
    endDateError: false,
    endTimeError: false,
    endTimeLogicError: false
  };

  get timezoneDisplay() {
    const timezone = localStorage.getItem('timezone') || defaultTimezone;
    return this.$tx('form.pop.tz', '应用店铺时区—{{timezone}}', { timezone });
  }

  get isAbtest() {
    return getQueryVariable('abtest') === 'true';
  }

  get isEditAbTest() {
    return getQueryVariable('abtest') === 'true' && getQueryVariable('edit') === 'true';
  }

  created() {
    this.initEffectiveTime();
  }

  private getShopTimezoneRaw() {
    return localStorage.getItem('timezone') || defaultTimezone;
  }

  private getShopZoneName() {
    const raw = this.getShopTimezoneRaw();
    return raw.split(' ')?.[1] || 'Asia/Shanghai';
  }

  private toShopMillis(date: string, timeWithSeconds: string) {
    const zone = this.getShopZoneName();
    const dt = DateTime.fromFormat(`${date} ${timeWithSeconds}`, 'yyyy-MM-dd HH:mm:ss', { zone });
    if (dt.isValid) return dt.toMillis();
    return new Date(`${date} ${timeWithSeconds}`).getTime();
  }

  initEffectiveTime() {
    const type = this.targeting?.scheduleType;
    const startTime = this.targeting?.startTime;
    const endTime = this.targeting?.endTime;

    if (type === 1 || startTime || endTime) {
      this.effectiveType = 'custom';
      if (startTime) {
        const parts = startTime.split(' ');
        this.effectiveStartDate = parts[0] || '';
        this.effectiveStartTime = parts[1] ? parts[1].substring(0, 5) : '';
      } else {
        this.effectiveStartDate = '';
        this.effectiveStartTime = '';
      }

      if (endTime) {
        const parts = endTime.split(' ');
        this.effectiveEndDate = parts[0] || '';
        this.effectiveEndTime = parts[1] ? parts[1].substring(0, 5) : '';
      } else {
        this.effectiveEndDate = '';
        this.effectiveEndTime = '';
      }
    } else {
      this.effectiveType = 'always';
      this.effectiveStartDate = '';
      this.effectiveStartTime = '';
      this.effectiveEndDate = '';
      this.effectiveEndTime = '';
    }
  }

  changeEffectiveType(val: string) {
    (window as any).gtagClick?.('form_list_schedule', '订阅工具_列表_生效设置');
    this.effectiveType = val;
    this.clearValidationErrors('all');

    if (val === 'always') {
      this.effectiveStartDate = '';
      this.effectiveStartTime = '';
      this.effectiveEndDate = '';
      this.effectiveEndTime = '';
    }

    this.updateEffectiveTime();
  }

  handleStartDateChange() {
    this.clearValidationErrors('startDate');
    this.updateEffectiveTime();
  }

  handleStartTimeChange() {
    this.clearValidationErrors('startTime');
    this.updateEffectiveTime();
  }

  handleEndDateChange() {
    this.clearValidationErrors('endDate');
    this.updateEffectiveTime();
  }

  handleEndTimeChange() {
    this.clearValidationErrors('endTime');
    this.updateEffectiveTime();
  }

  updateEffectiveTime() {
    if (!this.targeting) return;

    if (this.effectiveType === 'custom') {
      this.targeting.scheduleType = 1;

      if (this.effectiveStartDate && this.effectiveStartTime) {
        const timeStr = this.effectiveStartTime.length === 5 ? `${this.effectiveStartTime}:00` : this.effectiveStartTime;
        this.targeting.startTime = `${this.effectiveStartDate} ${timeStr}`;
      } else if (this.effectiveStartDate) {
        this.targeting.startTime = `${this.effectiveStartDate} 00:00:00`;
      } else {
        delete this.targeting.startTime;
      }

      if (this.effectiveEndDate && this.effectiveEndTime) {
        const timeStr = this.effectiveEndTime.length === 5 ? `${this.effectiveEndTime}:00` : this.effectiveEndTime;
        this.targeting.endTime = `${this.effectiveEndDate} ${timeStr}`;
      } else if (this.effectiveEndDate) {
        this.targeting.endTime = `${this.effectiveEndDate} 23:59:59`;
      } else {
        delete this.targeting.endTime;
      }
    } else {
      this.targeting.scheduleType = 0;
      delete this.targeting.startTime;
      delete this.targeting.endTime;
    }

    this.$emit('changeTargetingData', this.targeting);
  }

  validateEffectiveTime(): boolean {
    this.validation = {
      startDateError: false,
      startTimeError: false,
      endDateError: false,
      endTimeError: false,
      endTimeLogicError: false
    };

    if (this.effectiveType === 'custom') {
      let hasError = false;
      if (!this.effectiveStartDate) {
        this.validation.startDateError = true;
        hasError = true;
      }
      if (!this.effectiveStartTime) {
        this.validation.startTimeError = true;
        hasError = true;
      }
      if (hasError) {
        this.$message.error(this.$tx('form.pop.err.needStart', '自定义生效时间需设置开始时间'));
        return false;
      }

      const hasEndDate = !!this.effectiveEndDate;
      const hasEndTime = !!this.effectiveEndTime;
      if ((hasEndDate && !hasEndTime) || (!hasEndDate && hasEndTime)) {
        if (hasEndDate) {
          this.validation.endTimeError = true;
        } else {
          this.validation.endDateError = true;
        }
        this.$message.error(this.$tx('form.pop.err.endInvalid', '自定义生效时间结束时间设置异常'));
        return false;
      }

      if (hasEndDate && hasEndTime) {
        const startTimeStr = this.effectiveStartTime.length === 5 ? `${this.effectiveStartTime}:00` : this.effectiveStartTime;
        const endTimeStr = this.effectiveEndTime.length === 5 ? `${this.effectiveEndTime}:00` : this.effectiveEndTime;

        const startDateTime = this.toShopMillis(this.effectiveStartDate, startTimeStr);
        const endDateTime = this.toShopMillis(this.effectiveEndDate, endTimeStr);
        const currentTime = DateTime.now().setZone(this.getShopZoneName()).toMillis();

        if (endDateTime <= startDateTime || endDateTime <= currentTime) {
          this.validation.endDateError = true;
          this.validation.endTimeError = true;
          this.validation.endTimeLogicError = true;
          this.$message.error(this.$tx('form.pop.err.range', '自定义生效时间设置异常'));
          return false;
        }
      }
    }

    return true;
  }

  clearValidationErrors(field?: 'startDate' | 'startTime' | 'endDate' | 'endTime' | 'all') {
    if (!field || field === 'all') {
      this.validation = {
        startDateError: false,
        startTimeError: false,
        endDateError: false,
        endTimeError: false,
        endTimeLogicError: false
      };
      return;
    }

    switch (field) {
      case 'startDate':
        this.validation.startDateError = false;
        break;
      case 'startTime':
        this.validation.startTimeError = false;
        break;
      case 'endDate':
        this.validation.endDateError = false;
        this.validation.endTimeLogicError = false;
        break;
      case 'endTime':
        this.validation.endTimeError = false;
        this.validation.endTimeLogicError = false;
        break;
    }
  }

  valid() {
    return this.validateEffectiveTime();
  }

  save() {
    if (this.valid()) {
      this.$emit('save');
    }
    (window as any).gtagClick?.('form_tool_enable', '订阅工具_启用');
  }

  saveDraft() {
    if (this.isAbtest) {
      if (!this.isEditAbTest) {
        return;
      }
    }
    if (this.valid()) {
      this.$emit('saveDraft');
    }
    (window as any).gtagClick?.('form_tool_save', '订阅工具_保存草稿');
  }

  backStep() {
    if (this.valid()) {
      this.$emit('backStep');
    }
  }

  cancel() {
    if (this.valid()) {
      this.$emit('cancel');
    }
  }

  @Watch('targetingData')
  changetargetingData(val: any) {
    this.targeting = val;
    this.initEffectiveTime();
  }
}

export default PopSetting;
